import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

const FEATURES = [
  {
    icon: 'ri-layout-grid-line',
    title: '分类清晰',
    desc: '电影、电视剧、综艺三大频道，配合地区、年份、类型多条件筛选，快速定位想看的内容。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '检索高效',
    desc: '支持关键词搜索与结果反馈，输入片名即可找到对应作品，浏览路径简单直接。',
  },
  {
    icon: 'ri-bookmark-3-line',
    title: '收藏同步',
    desc: '一键收藏感兴趣的作品，收藏记录保存在本地浏览器，刷新后依然保留。',
  },
];

export default function SiteIntro() {
  const total = videos.length;
  const tvCount = videos.filter((item) => item.type === 'tv').length;

  const stats = [
    { value: `${total}+`, label: '收录影视作品' },
    { value: '3', label: '核心内容频道' },
    { value: `${tvCount}`, label: '连载剧集' },
    { value: '100%', label: '原创示范数据' },
  ];

  return (
    <section className="border-t border-background-200/80 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="font-label inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-accent-600">
              <span className="h-1 w-1 rounded-full bg-accent-500" />
              关于平台
            </span>
            <h2 className="font-heading mt-2 text-xl font-bold text-foreground-950 md:text-2xl">
              91视频在线 · 高清在线视频播放平台
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              91视频在线面向广大影视爱好者，专注于影视内容的聚合、分类与信息展示。我们以丰富的内容、清晰的分类和简单的操作，帮助用户快速浏览、筛选并了解感兴趣的影视资源，享受流畅、便捷的浏览体验。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              平台持续更新最新影视资讯与作品信息，覆盖电影、电视剧、综艺等主要品类。需要说明的是，站内播放区域为界面演示，暂未接入真实视频播放或在线流媒体服务；所有作品标题与简介均为原创示范数据。
            </p>
            <Link
              to="/about"
              className="font-label mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              了解完整介绍
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-4 md:gap-5">
            {FEATURES.map((feature) => (
              <div
                key={feature.title}
                className="rounded-lg border border-background-200/80 bg-background-50 p-4 md:p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${feature.icon} text-xl`} />
                </span>
                <h3 className="font-heading mt-3.5 text-sm font-bold text-foreground-950">{feature.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{feature.desc}</p>
              </div>
            ))}
            <div className="col-span-2 grid grid-cols-2 gap-4 rounded-lg border border-accent-200/70 bg-accent-50/70 p-4 md:col-span-2 md:grid-cols-4 md:p-5">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center md:text-left">
                  <p className="font-heading text-2xl font-extrabold text-accent-700">{stat.value}</p>
                  <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}